import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Button from "../button/Button";
import Dropdown from "../dropdown/Dropdown";
import Img from "../image/Img";
import { RootState } from "@/rematch/store/store";

function getLanguageFromURL(path: string): string | null {
  if (!path) return null;
  console.log("path", path);
  
  // Check first level path (/fr or /en)
  if (path === '/fr' || path === '/en') {
    return path.substring(1);
  }
  
  // Split path into segments and remove empty strings
  const pathSegments = path.split('/').filter(segment => segment);
  console.log("segments", pathSegments);
  
  // Iterate through segments from end to start
  for (let i = pathSegments.length - 1; i >= 0; i--) {
    const segment = pathSegments[i];
    console.log("checking segment", segment);
    
    if (segment.endsWith('-fr')) return 'fr';
    if (segment.endsWith('-en')) return 'en';
    if (segment === 'fr') return 'fr';
    if (segment === 'en') return 'en';
  }
  
  return null;
}

function getDefaultLanguage(path?: string): string {
  // First try to get language from URL
  if (path) {
    const urlLang = getLanguageFromURL(path);
    if (urlLang) return urlLang;
  }

  // Then try browser language
  if (typeof window !== 'undefined') {
    const browserLang = window.navigator.language.substring(0, 2);
    return browserLang === 'fr' ? 'fr' : 'en';
  }

  // Default fallback
  return 'en';
}

function NavBarContent({
  items,
  screenWidth,
  closeMenu,
  isLandscape,
  istablette,
}: any) {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const [indexPage, setindexPage] = useState(false);

  const currentRoute = router.asPath;

  useEffect(() => {
    if (currentRoute === "/" || currentRoute === "/fr" || currentRoute === "/en") {
      setindexPage(true);
    }
    // Check for language indicators in the route
    const pathSegments = currentRoute.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];
    
    if (lastSegment.endsWith('-fr') || currentRoute === "/fr") {
      i18n.changeLanguage("fr");
    } else if (lastSegment.endsWith('-en') || currentRoute === "/en") {
      i18n.changeLanguage("en");
    }
    return () => {
      setindexPage(false);
    };
  }, [router, currentRoute, i18n]);

  const isSticky = useSelector((state: RootState) => state.menuModel.scrollLeave);

  return (
    <>
      {items?.map((item: any, index: number) => {
        
        return (
          <div key={`nav-item-${index}`}>
            {item.type === "dropdown" ? (
              <Dropdown
                key={`dropdown-${index}`}
                closeMenu={closeMenu}
                breakpoint={screenWidth}
                style={item.style}
                title={item.title}
                href_en={item?.href_en ?? "#"}
                href_fr={item?.href_fr ?? "#"}
                items={item.elements}
                stickyCondition={screenWidth > 1024 && indexPage && !isSticky}
              />
            ) : item.type === "linkBtn" ? (
              <div onClick={closeMenu}>
                <>
                  {screenWidth <= 1024 ? (
                    <div
                      key={`mobile-nav-item-${index}`}
                      className="mobile-nav-item"
                    >
                      <Link
                        onClick={closeMenu}
                        className={`${screenWidth <= 1024
                          ? "text-reset text-decoration-none mobile-nav-item-font d-flex justify-content-between"
                          : "color-keeplin-dark"
                          } `}
                        href={item["href_" + i18n.language]}
                      >
                        {t(item?.title)}
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.62305 11.7884C3.62305 11.5527 3.7127 11.3169 3.89261 11.137L8.15402 6.87616L3.89261 2.61536C3.5334 2.25554 3.5334 1.6722 3.89261 1.31238C4.25243 0.953166 4.83577 0.953166 5.19559 1.31238L10.1079 6.22466C10.4671 6.58449 10.4671 7.16782 10.1079 7.52765L5.19559 12.4399C4.83577 12.7991 4.25243 12.7991 3.89261 12.4399C3.7127 12.26 3.62305 12.0242 3.62305 11.7884Z"
                            fill="#F3BA05"
                          />
                        </svg>
                      </Link>
                    </div>
                  ) : (
                    <Button
                      key={`button-${index}`}
                      title={item.title}
                      href={item["href_" + i18n.language]}
                      variant="btnLink"
                      animated={true}
                      className="mt-lg-0 mt-5"
                      titleStyle={"font-500"}
                    />
                  )}
                </>
              </div>
            ) : screenWidth <= 1024 ? (
              <div key={`mobile-nav-item-${index}`} className="mobile-nav-item">
                <Link
                  onClick={closeMenu}
                  className={`${screenWidth <= 1024
                    ? "text-reset text-decoration-none mobile-nav-item-font d-flex justify-content-between"
                    : "color-keeplin-dark"
                    } `}
                  href={item["href_" + i18n.language]}
                >
                  {t(item?.title)}
                  {item["href_" + i18n.language] != "/#our-services" && (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.62305 11.7884C3.62305 11.5527 3.7127 11.3169 3.89261 11.137L8.15402 6.87616L3.89261 2.61536C3.5334 2.25554 3.5334 1.6722 3.89261 1.31238C4.25243 0.953166 4.83577 0.953166 5.19559 1.31238L10.1079 6.22466C10.4671 6.58449 10.4671 7.16782 10.1079 7.52765L5.19559 12.4399C4.83577 12.7991 4.25243 12.7991 3.89261 12.4399C3.7127 12.26 3.62305 12.0242 3.62305 11.7884Z"
                        fill="#F3BA05"
                      />
                    </svg>
                  )}
                </Link>
              </div>
            ) : (
              <Link
                key={`link-${index}`}
                className={` ${screenWidth <= 1024
                  ? "text-reset text-decoration-none mobile-nav-item-font"
                  : `${screenWidth > 1024 && indexPage && !isSticky
                    ? "nav-link navbar-items nav-link color-keeplin-dark"
                    : "nav-link navbar-items nav-link navbar-items"
                  }`
                  } ${currentRoute.replaceAll("/", "") ===
                    item["href_" + i18n.language]?.replaceAll("/", "")
                    ? " active "
                    : ""
                  } `}
                href={item["href_" + i18n.language]}
              >
                {t(item?.title)}
              </Link>
            )}
          </div>
        );
      })}
    </>
  );
}

export default function Navbar({ items }: any) {
  const router = useRouter();
  const [indexPage, setindexPage] = useState(false);
  const currentRoute = router.asPath;
  const { i18n } = useTranslation();
  const isSticky = useSelector((state: RootState) => state.menuModel.scrollLeave);

  // Handle language detection
  useEffect(() => {
    // Check if we're on index page
    if (currentRoute === "/" || currentRoute === "/fr" || currentRoute === "/en") {
      setindexPage(true);
    }

    // Try to get language from URL
    const urlLang = getLanguageFromURL(currentRoute);
    
    if (urlLang) {
      // If URL has language indicator, use it
      i18n.changeLanguage(urlLang);
    } else if (!i18n.language || i18n.language === 'undefined') {
      // If no URL language and no language set, use browser default
      const defaultLang = getDefaultLanguage();
      i18n.changeLanguage(defaultLang);
    }

    return () => {
      setindexPage(false);
    };
  }, [currentRoute, i18n]);

  const [isOpen, setToggleMenu] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const [screenWidth, setScreenWidth] = useState(0);
  const [isLandscape, setIsLandscape] = useState(false);
  const handleWindowResize = () => {
    setScreenWidth(window.innerWidth);
    setIsLandscape(window.matchMedia("(orientation: landscape)").matches);
    const { userAgent } = window.navigator;
    const isTabletDevice =
      /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);

    setIsTablet(isTabletDevice);
  };

  const handleMenu = () => {
    setToggleMenu(!isOpen);
  };

  const mobileContainer = useRef(null);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    if (screenWidth > 1024) {
      setToggleMenu(false);
    }

    return () => window.removeEventListener("resize", handleWindowResize);
  });

  //useOutsideAlerter(mobileContainer, screenWidth, isOpen, ()=> setToggleMenu(false))

  return (
    // <nav
    //   className="navbar navbar-expand-lg "
    //   style={
    //     screenWidth > 1024 && indexPage && !isSticky
    //       ? {} //{ backgroundColor: "transparent", top:'1.3rem',position: "absolute",paddingTop: "27px !important"
    //       : // , paddingBottom: "15px !important " }
    //       {}
    //   }
    // >
    //   <div
    //     className="container-fluid"
    //     style={
    //       screenWidth > 1024 && indexPage && !isSticky
    //         ? {} //{ width: '90%',
    //         : // background: '#fff',
    //         //padding: '1rem 0 1rem 0' }
    //         {}
    //     }
    //   >
    //     <div
    //       className={
    //         (indexPage
    //           ? "navbar-container"
    //           : screenWidth < 1025 && screenWidth > 767
    //             ? "navbar-container"
    //             : "navbar-container") +
    //         (screenWidth > 1199 && !indexPage ? "  " : " ")
    //       }
    //       style={
    //         screenWidth > 1024 && indexPage && !isSticky
    //           ? undefined //{ margin: "0 50px" }
    //           : screenWidth < 1025
    //             ? undefined //{ marginLeft: "0px" }
    //             : undefined
    //       }
    //     >
    //       <Link href="/" className="navbar-brand">
    //         {screenWidth > 1024 && indexPage && !isSticky ? (
    //           <Img
    //             image="/LOGOPLEIN.png"
    //             alt="Welcome | Keeplin"
    //             width={220}
    //             height={30.15}
    //           // style={{ marginLeft: "10%" }}
    //           />
    //         ) : (
    //           <Img
    //             image="/LOGOPLEIN.png"
    //             alt="Welcome | Keeplin"
    //             width={200}
    //             height={30.15}
    //           // style={{ marginLeft: "10%" }}
    //           />
    //         )}
    //       </Link>
    //       {screenWidth < 1025 && !isOpen && (
    //         <button 
    //           className="btn" 
    //           onClick={handleMenu}
    //           aria-label="Toggle navigation menu"
    //         >
    //           <svg
    //             width="42"
    //             height="40"
    //             viewBox="0 0 42 40"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //             aria-hidden="true"
    //           >
    //             <rect
    //               x="5"
    //               y="10.5"
    //               width="32"
    //               height="3"
    //               rx="1.5"
    //               fill="#5049B5"
    //             />
    //             <rect
    //               x="5"
    //               y="18.5"
    //               width="32"
    //               height="3"
    //               rx="1.5"
    //               fill="#5049B5"
    //             />
    //             <rect
    //               x="5"
    //               y="26.5"
    //               width="32"
    //               height="3"
    //               rx="1.5"
    //               fill="#5049B5"
    //             />
    //           </svg>
    //         </button>
    //       )}
    //       <div
    //         // style={indexPage ? { marginRight: "2%" } : { marginRight: "-10%" }}
    //         className={`${indexPage ? "marginNavbarIndex" : "marginNavbarIndex"
    //           }  ${screenWidth < 1025 && isOpen
    //             ? "mobile-nav-item-container d-flex "
    //             : screenWidth < 1025 && !isOpen
    //               ? "mobile-nav-item-container d-none"
    //               : "navbar-items-container d-flex"
    //           }`}
    //       >
    //         {screenWidth < 1025 && (
    //           <div
    //             className="mobile-nav-header   d-flex
    //           align-items-center
    //           px-2
    //           justify-content-between"
    //           >
    //             <Link href="/" onClick={() => setToggleMenu(false)}>
    //               <Img
    //                 image="/LOGOPLEIN.png"
    //                 alt="Welcome | Keeplin"
    //                 width={138}
    //                 height={30.15}
    //               />
    //             </Link>
    //             <button
    //               className=""
    //               onClick={handleMenu}
    //               style={{ border: "none", background: "white" }}
    //             >
    //               <svg
    //                 width="42"
    //                 height="40"
    //                 viewBox="0 0 42 40"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <rect
    //                   x="5"
    //                   y="10.5"
    //                   width="32"
    //                   height="3"
    //                   rx="1.5"
    //                   fill="#5049B5"
    //                 />
    //                 <rect
    //                   x="5"
    //                   y="18.5"
    //                   width="32"
    //                   height="3"
    //                   rx="1.5"
    //                   fill="#5049B5"
    //                 />
    //                 <rect
    //                   x="5"
    //                   y="26.5"
    //                   width="32"
    //                   height="3"
    //                   rx="1.5"
    //                   fill="#5049B5"
    //                 />
    //               </svg>
    //             </button>
    //           </div>
    //         )}
    //         {screenWidth < 1025 ? (
    //           <div className={"mobile-nav-content dropdown-item-border"}>
    //             <NavBarContent
    //               closeMenu={() => setToggleMenu(false)}
    //               items={items}
    //               screenWidth={screenWidth}
    //               isLandscape={isLandscape}
    //               istablette={isTablet}
    //             />
    //           </div>
    //         ) : (
    //           <NavBarContent
    //             items={items}
    //             screenWidth={screenWidth}
    //             isLandscape={isLandscape}
    //             istablette={isTablet}
    //           />
    //         )}
    //       </div>
    //     </div>
    //   </div>
    //   {isOpen && screenWidth < 1025 && (
    //     <div className="mobile-nav-container">
    //       <button className="btn close-btn" style={{ background: "#00000000" }}>
    //         <i className="bi bi-x-lg" onClick={handleMenu}></i>
    //       </button>
    //     </div>
    //   )}
    // </nav>
    <header>
    <div className="navbar-menu">
      <div className="container">
        <div className="logo text-center">
          <Link href="/">
            <img src="/images/mas/logo.svg" alt="le mas de mon père"
          /></Link>
        </div>
      </div>
    </div>
  </header>
  );
}
